MealPlanDayModel.$inject = ["$modelFactory", "MealModel"];function _typeof(obj) {if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {_typeof = function _typeof(obj) {return typeof obj;};} else {_typeof = function _typeof(obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};}return _typeof(obj);}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}function _possibleConstructorReturn(self, call) {if (call && (_typeof(call) === "object" || typeof call === "function")) {return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}import { toFloat } from "../../shared/helpers/to-float";

export var mealPlanDayDefaults = {
  logged_meals_number: 0,
  logged_meals_calories: "", // "0.00"
  logged_meals_carbohydrates: "", // "0.00"
  logged_meals_fats: "", // "0.00"
  logged_meals_proteins: "", // "0.00"
  skipped_meals_number: 0,
  skipped_meals_calories: "", // "0.00"
  skipped_meals_carbohydrates: "", // "0.00"
  skipped_meals_fats: "", // "0.00"
  skipped_meals_proteins: "", // "0.00"
  planned_meals_number: 0,
  planned_meals_calories: "", // "0.00"
  planned_meals_carbohydrates: "", // "0.00"
  planned_meals_fats: "", // "0.00"
  planned_meals_proteins: "", // "0.00"
  day_number: 1,
  meals: [/*meal*/] };


export function MealPlanDayModel($modelFactory, MealModel) {
  "ngInject";var

  MealPlanDay = /*#__PURE__*/function (_$modelFactory) {_inherits(MealPlanDay, _$modelFactory);function MealPlanDay() {_classCallCheck(this, MealPlanDay);return _possibleConstructorReturn(this, (MealPlanDay.__proto__ || Object.getPrototypeOf(MealPlanDay)).apply(this, arguments));}_createClass(MealPlanDay, [{ key: "completedPercentage", get: function get()

















      {
        return Math.round(
        (this.logged_meals_number || 0) / (this.planned_meals_number || 1) * 100);

      } }]);return MealPlanDay;}($modelFactory('mealplanday', { defaults: mealPlanDayDefaults, map: { logged_meals_calories: toFloat, logged_meals_carbohydrates: toFloat, logged_meals_fats: toFloat, logged_meals_proteins: toFloat, skipped_meals_calories: toFloat, skipped_meals_carbohydrates: toFloat, skipped_meals_fats: toFloat, skipped_meals_proteins: toFloat, planned_meals_calories: toFloat, planned_meals_carbohydrates: toFloat, planned_meals_fats: toFloat, planned_meals_proteins: toFloat, meals: MealModel.List } }));

  MealPlanDay.List.Model = MealPlanDay;

  return MealPlanDay;

}